import { render, staticRenderFns } from "./buscador-becarios.vue?vue&type=template&id=090ce202&scoped=true&"
import script from "./buscador-becarios.component.ts?vue&type=script&lang=ts&"
export * from "./buscador-becarios.component.ts?vue&type=script&lang=ts&"
import style0 from "./buscador-becarios.vue?vue&type=style&index=0&id=090ce202&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090ce202",
  null
  
)

export default component.exports